module.exports = __webpack_public_path__ + "img/13.d39b565a.webp";